import _defineProperty from '../../node_modules/@babel/runtime/helpers/defineProperty.js';
import _asyncToGenerator from '../../node_modules/@babel/runtime/helpers/asyncToGenerator.js';
import _slicedToArray from '../../node_modules/@babel/runtime/helpers/slicedToArray.js';
import _taggedTemplateLiteral from '../../node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js';
import regenerator from '../../node_modules/@babel/runtime/regenerator/index.js';
import { Form, Flex, mediaMixin, spaceMixin, Button, BUTTON_TYPES } from '@zillow/constellation';
import { useForm } from '../../node_modules/react-hook-form/dist/index.esm.js';
import styled, { css } from 'styled-components';
import { useState, useEffect, useCallback } from 'react';
import Outputs from './outputs/Outputs.js';
import { INPUTS } from './constants.js';
import AnnualIncomeField from './form-fields/AnnualIncomeField.js';
import CreditSelectField from './form-fields/CreditSelectField.js';
import DownPaymentField from './form-fields/DownPaymentField.js';
import MonthlyDebtField from './form-fields/MonthlyDebtField.js';
import LocationField from './form-fields/LocationField.js';
import { performCalculation } from './api.js';
import useCalculatorContext from './useCalculatorContext.js';
import { trackGACalculatorVisible, trackGAFieldFocus, trackGAMortgageEvent, trackGACalculatorOutcome } from './analytics.js';
import jsxRuntime from '../../node_modules/react/jsx-runtime.js';

var _templateObject, _templateObject2, _templateObject3;
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var Wrapper = styled(Form)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    display: flex;\n    flex-direction: column;\n"])));
var FieldsWrapper = styled(Flex)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    ", "\n"])), mediaMixin('lg', css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n            max-width: 375px;\n            width: 375px;\n            padding-right: ", ";\n        "])), spaceMixin('md'))));
var CalculatorForm = function CalculatorForm() {
  var _useCalculatorContext = useCalculatorContext(),
    outputs = _useCalculatorContext.outputs,
    updateOutputs = _useCalculatorContext.updateOutputs;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isCalculating = _useState2[0],
    setIsCalculating = _useState2[1];
  var _useForm = useForm({
      mode: 'onBlur',
      shouldUnregister: true
    }),
    _useForm$formState = _useForm.formState,
    errors = _useForm$formState.errors,
    isValid = _useForm$formState.isValid,
    register = _useForm.register,
    setValue = _useForm.setValue,
    trigger = _useForm.trigger,
    clearErrors = _useForm.clearErrors,
    watch = _useForm.watch,
    handleSubmit = _useForm.handleSubmit;
  var cityOrZip = watch(INPUTS.cityOrZip, '');
  var disabled = !isValid || isCalculating;
  useEffect(function () {
    trackGACalculatorVisible();
  }, []);
  var handleFocus = useCallback(function (e) {
    var _e$target;
    return trackGAFieldFocus((_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.id);
  }, []);
  var handleLocationFocus = useCallback(function () {
    return trackGAFieldFocus(INPUTS.cityOrZip);
  }, []);
  var onSubmit = useCallback( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee(inputFields, e) {
      var result;
      return regenerator.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              e.preventDefault();
              setIsCalculating(true);
              trackGAMortgageEvent('Budget Calculator: Interaction', 'Calculate Button');
              _context.prev = 3;
              _context.next = 6;
              return performCalculation(inputFields);
            case 6:
              result = _context.sent;
              trackGACalculatorOutcome(result);
              updateOutputs(_objectSpread({
                inputFields: inputFields
              }, result));
              _context.next = 14;
              break;
            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](3);
              trackGAMortgageEvent('Budget Calculator: Interaction', "Calculator Error: \"".concat(JSON.stringify(inputFields), "\" | error: \"").concat(JSON.stringify(_context.t0), "\""));
            case 14:
              setIsCalculating(false);
            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[3, 11]]);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }(), [updateOutputs]);
  return /*#__PURE__*/jsxRuntime.jsx(jsxRuntime.Fragment, {
    children: /*#__PURE__*/jsxRuntime.jsxs(Wrapper, {
      onSubmit: handleSubmit(onSubmit),
      children: [/*#__PURE__*/jsxRuntime.jsxs(Flex, {
        display: "flex",
        flexDirection: {
          "default": 'column',
          lg: 'row'
        },
        justifyContent: "center",
        children: [/*#__PURE__*/jsxRuntime.jsxs(FieldsWrapper, {
          display: "flex",
          flexDirection: "column",
          flex: "1",
          children: [/*#__PURE__*/jsxRuntime.jsx(AnnualIncomeField, {
            register: register,
            name: INPUTS.annualIncome,
            error: errors === null || errors === void 0 ? void 0 : errors.annualIncome,
            onFocus: handleFocus
          }), /*#__PURE__*/jsxRuntime.jsx(MonthlyDebtField, {
            register: register,
            name: INPUTS.monthlyDebts,
            error: errors === null || errors === void 0 ? void 0 : errors.monthlyDebts,
            onFocus: handleFocus
          }), /*#__PURE__*/jsxRuntime.jsx(DownPaymentField, {
            register: register,
            name: INPUTS.downPayment,
            error: errors === null || errors === void 0 ? void 0 : errors.downPayment,
            onFocus: handleFocus
          }), /*#__PURE__*/jsxRuntime.jsx(CreditSelectField, {
            register: register,
            name: INPUTS.creditScore,
            onFocus: handleFocus
          }), /*#__PURE__*/jsxRuntime.jsx(LocationField, {
            value: cityOrZip,
            register: register,
            setValue: setValue,
            errors: errors,
            trigger: trigger,
            clearErrors: clearErrors,
            onFocus: handleLocationFocus
          })]
        }), /*#__PURE__*/jsxRuntime.jsx(Flex, {
          display: "flex",
          flex: "1",
          justifyContent: "center",
          marginTop: {
            "default": 'md',
            lg: 0
          },
          children: /*#__PURE__*/jsxRuntime.jsx(Outputs, {
            outputs: outputs,
            isCalculating: isCalculating
          })
        })]
      }), /*#__PURE__*/jsxRuntime.jsx(Button, {
        buttonType: BUTTON_TYPES.secondary,
        marginTop: "lg",
        fluid: true,
        disabled: disabled,
        children: "Calculate"
      })]
    })
  });
};
var CalculatorForm$1 = CalculatorForm;

export { CalculatorForm$1 as default };
//# sourceMappingURL=CalculatorForm.js.map
